// @ts-nocheck

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initHomeIndex() {

// Toggle Menu Mobile
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
const navbarMenu = document.querySelector('.navbar-menu');

if (mobileMenuToggle && navbarMenu) {
    mobileMenuToggle.addEventListener('click', () => {
        navbarMenu.classList.toggle('active');
        const isExpanded = navbarMenu.classList.contains('active');
        mobileMenuToggle.setAttribute('aria-expanded', isExpanded);
    });
}

// Navbar Scroll Effect — toggle `.scrolled` when the hero leaves the viewport
const navbar = document.querySelector('.navbar');
const hero = document.querySelector('.hero-section');

function setNavbarScrolled(scrolled) {
    if (!navbar) return;
    if (scrolled) navbar.classList.add('scrolled');
    else navbar.classList.remove('scrolled');
}

if (hero && navbar) {
    // Progressive navbar darkening while scrolling inside the hero.
    // We'll compute a `progress` [0..1] representing how much of the hero
    // the user has scrolled and use it to set background alpha and text color.
    let ticking = false;

    function updateNavbarProgress() {
        const heroRect = hero.getBoundingClientRect();
        const heroTopPage = window.scrollY + heroRect.top;
        const heroHeight = heroRect.height || 1;

        // scrolled amount inside the hero (clamped)
        const scrolledInside = Math.min(Math.max(window.scrollY - heroTopPage, 0), heroHeight);
        const progress = Math.max(0, Math.min(1, scrolledInside / heroHeight));

        const maxOpacity = 0.92; // matches CSS .scrolled background alpha
        const bgAlpha = progress * maxOpacity;

        // Apply background and visual effects
        navbar.style.backgroundColor = bgAlpha > 0 ? `rgba(0,0,0,${bgAlpha})` : 'transparent';
        navbar.style.boxShadow = bgAlpha > 0 ? `0 4px 18px rgba(0,0,0,${0.25 * progress})` : 'none';
        navbar.style.backdropFilter = `blur(${8 * progress}px)`;

        // Text color: interpolate from black (0) to white (255)
        const colorVal = Math.round(255 * progress);
        const textColor = `rgb(${colorVal}, ${colorVal}, ${colorVal})`;

        // Apply to menu links and login and hamburger spans
        document.querySelectorAll('.navbar-menu a, .navbar-login').forEach(el => {
            el.style.color = textColor;
        });
        document.querySelectorAll('.mobile-menu-toggle span').forEach(el => {
            el.style.background = textColor;
        });
        
        // Apply styles to language select
        const languageSelect = document.querySelector('.navbar-language select');
        if (languageSelect) {
            languageSelect.style.color = textColor;
            if (progress > 0.5) {
                // Quando navbar está ficando preta, adicionar background
                const bgAlpha = (progress - 0.5) * 2; // 0 a 1 quando progress > 0.5
                languageSelect.style.backgroundColor = `rgba(0, 0, 0, ${bgAlpha * 0.5})`;
                languageSelect.style.borderColor = `rgba(255, 255, 255, ${0.3 * progress})`;
            } else {
                languageSelect.style.backgroundColor = 'transparent';
                languageSelect.style.borderColor = 'rgba(0, 0, 0, 0.15)';
            }
        }

        // Toggle the `.scrolled` class when progress is essentially 1 (hero fully scrolled out)
        if (progress >= 0.995) navbar.classList.add('scrolled');
        else navbar.classList.remove('scrolled');

        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(updateNavbarProgress);
            ticking = true;
        }
    }, { passive: true });

    // Update on load and resize so values are correct
    window.addEventListener('resize', () => {
        updateNavbarProgress();
    });
    // Initial call
    updateNavbarProgress();
} else if (navbar) {
    // fallback: simple scroll threshold
    window.addEventListener('scroll', () => {
        setNavbarScrolled(window.scrollY > 100);
    });
}

// Back to Top Button
const backToTopButton = document.querySelector('.btn-back-top');

if (backToTopButton) {
    backToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    
    window.addEventListener('scroll', () => {
        if (window.scrollY > 500) {
            backToTopButton.style.opacity = '1';
            backToTopButton.style.pointerEvents = 'auto';
        } else {
            backToTopButton.style.opacity = '0';
            backToTopButton.style.pointerEvents = 'none';
        }
    });
}

// Lazy Loading para imagens
const images = document.querySelectorAll('img[loading="lazy"]');
if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                }
                observer.unobserve(img);
            }
        });
    });
    
    images.forEach(img => {
        if (img.dataset.src) {
            imageObserver.observe(img);
        }
    });
}

// Play Button Functionality
const playButtons = document.querySelectorAll('.play-button');

playButtons.forEach(button => {
    button.addEventListener('click', function() {
        const card = this.closest('.radio-card, .content-card');
        // Aqui você pode adicionar a lógica para tocar a rádio
        console.log('Tocar rádio:', card?.querySelector('h3')?.textContent);
    });
});

// Smooth Scroll para links internos (apenas âncoras que começam com #)
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        const targetAttr = this.getAttribute('target');
        
        // Ignorar links com target="_blank" ou outros targets
        if (targetAttr) {
            return; // Deixar comportamento padrão
        }
        
        // Verificar se é realmente uma âncora (começa com # e não é apenas #)
        // Também verificar se não é uma URL externa (pode ter sido atualizada dinamicamente)
        if (href && href.startsWith('#') && href.length > 1 && !href.startsWith('http')) {
            e.preventDefault();
            try {
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            } catch (error) {
                // Se houver erro (href inválido como seletor), deixar comportamento padrão
                console.warn('Invalid selector for smooth scroll:', href);
            }
        }
        // Se não for uma âncora válida, deixar o comportamento padrão do link
    });
});

/* -----------------------------
   Carousel (carrossel)
   - initialize all carousels on the page
   - each carousel is independent and uses the same autoplay/pause/dots logic
------------------------------*/
(function initCarousels() {
    // Skip carrossel-main and carrossel-radio - they use Swiper now
    const carousels = document.querySelectorAll('.carrossel:not(.carrossel-radio):not(.carrossel-main)');
    if (!carousels || carousels.length === 0) return;

    carousels.forEach((carousel) => {
        const track = carousel.querySelector('.carousel-track');
        const dotsContainer = carousel.querySelector('.carousel-dots');
        if (!track || !dotsContainer) return;

        const originalItems = Array.from(track.children);
        const count = originalItems.length;
        if (count === 0) return;

        // state for this carousel
    const visible = Math.max(1, parseInt(carousel.dataset.visible || '1'));
    // Optional fixed item size (px). If provided, slides will use this width on
    // viewports larger than mobileBreakpoint. Example: <section class="carrossel" data-item-width="360" data-item-height="220">
    const itemWidthAttr = carousel.dataset.itemWidth ? parseInt(carousel.dataset.itemWidth, 10) : null;
    const itemHeightAttr = carousel.dataset.itemHeight ? parseInt(carousel.dataset.itemHeight, 10) : null;
    const mobileBreakpoint = parseInt(carousel.dataset.mobileBreakpoint || '900', 10);
    let itemWidth = carousel.clientWidth / visible;
    let pos = 0;
        let lastTime = null;
        let running = true;
        // gap (px) read from computed style; perSlide is the distance between slide starts
        let gapPx = 0;
        let perSlide = itemWidth; // itemWidth + gapPx (set in setWidths)
        let baseWidth = perSlide * count;
        const speed = 80; // px per second
        let resumeTimeout = null;
        const resumeDelay = 30000; // 30s
    let lastDotIndex = -1;

        function clearResume() {
            if (resumeTimeout) {
                clearTimeout(resumeTimeout);
                resumeTimeout = null;
            }
        }

        function scheduleResume() {
            clearResume();
            resumeTimeout = setTimeout(() => {
                setRunning(true);
                resumeTimeout = null;
            }, resumeDelay);
        }

        function setRunning(state) {
            running = !!state;
            if (running) {
                carousel.classList.remove('paused');
                clearResume();
            } else {
                carousel.classList.add('paused');
            }
        }

        function getActiveIndex() {
            // active index based on the center/original region
            if (baseWidth === 0 || itemWidth === 0) return 0;
            // position offset relative to the start of original region
            const rel = pos - baseWidth;
            const raw = Math.round(rel / perSlide);
            return ((raw % count) + count) % count;
        }

        function setWidths() {
            // If a fixed item width is provided and we are above the mobile breakpoint,
            // use that fixed width; otherwise compute width from the carousel width and visible count.
            if (itemWidthAttr && window.innerWidth > mobileBreakpoint) {
                itemWidth = itemWidthAttr;
            } else {
                itemWidth = Math.max(1, Math.floor(carousel.clientWidth / visible));
            }

            Array.from(track.children).forEach(child => {
                // Force exact width so items do not stretch
                child.style.width = itemWidth + 'px';
                child.style.minWidth = itemWidth + 'px';
                // If a fixed height is specified, apply it (desktop only)
                if (itemHeightAttr && window.innerWidth > mobileBreakpoint) {
                    child.style.height = itemHeightAttr + 'px';
                } else {
                    child.style.height = '';
                }
            });
            // read gap from computed style (supports gap or columnGap)
            try {
                const cs = getComputedStyle(track);
                gapPx = parseFloat(cs.gap || cs.columnGap || '0') || 0;
            } catch (e) {
                gapPx = 0;
            }

            perSlide = itemWidth + gapPx;
            baseWidth = perSlide * count;
            // Hint the browser that transform will change; promotes to its own layer
            if (track && track.style) {
                track.style.willChange = 'transform';
                track.style.transform = `translate3d(${-pos}px,0,0)`;
            }
        }

        // build dots (listeners attached later depending on carousel type)
        const dots = [];
        for (let i = 0; i < count; i++) {
            const dot = document.createElement('button');
            dot.className = 'carousel-dot';
            dot.type = 'button';
            dot.dataset.index = i;
            dotsContainer.appendChild(dot);
            dots.push(dot);
        }


    // clone items both before and after to allow seamless infinite scroll
    // track contents will be: [clonesBefore..., originals..., clonesAfter...]
    const clonesBefore = originalItems.map(node => node.cloneNode(true));
    const clonesAfter = originalItems.map(node => node.cloneNode(true));
    // prepend clonesBefore in reverse order so visual sequence stays the same
    clonesBefore.reverse().forEach(n => track.insertBefore(n, track.firstChild));
    // append clonesAfter
    clonesAfter.forEach(n => track.appendChild(n));

    // initialize sizes and set starting position in the middle (after the prepended clones)
    setWidths();
    // Start at the first original item which is `count` items from the start
    pos = baseWidth;
    if (track && track.style) track.style.transform = `translate3d(${-pos}px,0,0)`;

        // Pause autoplay when the carousel leaves the viewport to save CPU/GPU.
        // We preserve the user's pause state by storing previous running state.
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        // store previous running state so we can restore only if it was running
                        carousel.dataset._prevRunning = running ? 'true' : 'false';
                        setRunning(false);
                    } else {
                        if (carousel.dataset._prevRunning === 'true') {
                            setRunning(true);
                        }
                        delete carousel.dataset._prevRunning;
                    }
                });
            }, { threshold: 0 });
            io.observe(carousel);
        }

        window.addEventListener('resize', () => {
            // Preserve visual index when resizing: compute active index relative to originals
            const activeIndex = getActiveIndex();
            setWidths();
            // reposition to the middle copy for seamless looping (use perSlide which includes gap)
            pos = baseWidth + (activeIndex * perSlide);
            track.style.transition = 'none';
            track.style.transform = `translate3d(${-pos}px,0,0)`;
        });

        function updateDots() {
            if (baseWidth === 0 || itemWidth === 0) return;
            const idx = getActiveIndex();
            if (idx === lastDotIndex) return; // avoid DOM churn when unchanged
            lastDotIndex = idx;
            dots.forEach((d, i) => d.classList.toggle('active', i === idx));
        }

        function goToIndex(index) {
            // jump to the index inside the original region (which starts at baseWidth)
            pos = baseWidth + (index * perSlide);
            track.style.transition = 'transform 480ms ease';
            track.style.transform = `translate3d(${-pos}px,0,0)`;
            updateDots();

            const cleanup = () => {
                track.style.transition = 'none';
                track.removeEventListener('transitionend', cleanup);
            };
            track.addEventListener('transitionend', cleanup);
            clearResume();
        }

        // attach listeners to dots for non-main carousels
        dots.forEach((d, i) => {
            d.addEventListener('click', () => {
                const current = getActiveIndex();
                // If user clicked the active dot, toggle pause/resume
                if (i === current) {
                    if (carousel.classList.contains('paused')) {
                        // was paused -> resume immediately
                        setRunning(true);
                        clearResume();
                    } else {
                        // was running -> pause and schedule automatic resume
                        setRunning(false);
                        scheduleResume();
                    }
                    return;
                }
                // navigate to the requested index and pause the automatic scroll
                goToIndex(i);
                setRunning(false);
                // schedule resume after the configured delay
                scheduleResume();
            });
        });

        function step(timestamp) {
            if (!lastTime) lastTime = timestamp;
            const dt = timestamp - lastTime;
            lastTime = timestamp;

            if (running) {
                pos += (speed * dt) / 1000;
                // when moving past the second copy of originals, jump back by one originals width
                if (pos >= baseWidth * 2) {
                    pos = pos - baseWidth;
                    // immediately apply the corrected transform without transition to avoid visible jump
                    track.style.transition = 'none';
                    track.style.transform = `translate3d(${-pos}px,0,0)`;
                    // force a reflow so the browser applies the non-transitioned transform
                    // before subsequent rAF-driven transforms — this avoids a tiny visual jump
                    /* eslint-disable no-unused-expressions */
                    track.getBoundingClientRect();
                    /* eslint-enable no-unused-expressions */
                }
                // also handle the (unlikely) case of going before the first copy
                if (pos < 0) {
                    pos = pos + baseWidth;
                    track.style.transition = 'none';
                    track.style.transform = `translate3d(${-pos}px,0,0)`;
                    track.getBoundingClientRect();
                }
                // use translate3d for GPU compositing; rAF updates happen without CSS transition
                track.style.transform = `translate3d(${-pos}px,0,0)`;
            }

            updateDots();
            requestAnimationFrame(step);
        }

        // start animation loop for this carousel
        requestAnimationFrame(step);

        // expose a small API
        carousel._carousel = { goToIndex: goToIndex, pause: () => setRunning(false), play: () => setRunning(true) };
    });

})();

/* ==================================================
   Music Player Integration
   Conecta o RadioManager com o music player do hero
   ================================================== */

const APPRADIO_STREAM_HANDOFF_KEY = 'appradio_stream_handoff_v1';
const APPRADIO_STREAM_HANDOFF_TTL_MS = 4 * 60 * 60 * 1000;

class MusicPlayerManager {
    constructor() {
        this.audio = null;
        this.currentRadio = null;
        this.isPlaying = false;
        this.isLoading = false;
        this.musicIdentifier = null;
        this.isIdentifyingMusic = false;
        this.lastIdentificationTime = 0;
        this.identificationCooldown = 30000;
        this.identificationTimer = null;
        this.lastTrackRadioId = null;
        this.lastTrackInfo = null; // Armazena última música identificada
        this.hasPlaybackError = false;
        this.needsUserPlay = false;
        this.streamAttemptStartedAt = null;
        this.init();
    }

    init() {
        // Criar elemento de áudio único
        this.audio = new Audio();
        this.audio.preload = 'none';
        this.hls = null;

        // Eventos do áudio
        this.audio.addEventListener('loadstart', () => {
            this.isLoading = true;
            this.updatePlayerUI();
            this.emitStreamState('loading');
        });

        this.audio.addEventListener('canplay', () => {
            this.isLoading = false;
            this.updatePlayerUI();
            this.emitStreamState('canplay');
        });

        this.audio.addEventListener('play', () => {
            this.isPlaying = true;
            this.isLoading = false;
            this.needsUserPlay = false;
            this.hasPlaybackError = false;
            this.updatePlayerUI();
            this.scheduleNextIdentification();
            this.emitStreamState('playing');
        });

        this.audio.addEventListener('pause', () => {
            this.isPlaying = false;
            this.updatePlayerUI();
            this.scheduleNextIdentification();
            this.emitStreamState('paused');
        });

        this.audio.addEventListener('ended', () => {
            this.isPlaying = false;
            this.updatePlayerUI();
            this.emitStreamState('ended');
        });

        this.audio.addEventListener('error', (e) => {
            console.error('Erro no player de música:', e);
            this.isPlaying = false;
            this.isLoading = false;
            this.hasPlaybackError = true;
            this.updateMusicInfo({
                title: 'Não foi possível tocar.',
                artist: 'Formato de áudio não suportado ou stream indisponível.',
                label: 'Rádio indisponível'
            });
            this.updatePlayerUI();
            this.emitStreamState('error');
        });

        // Listener para eventos do RadioManager
        document.addEventListener('radio-play', (e) => {
            this.playRadio(e.detail.streamUrl, e.detail.radioName, e.detail.radioId, {
                urlLogo: e.detail.urlLogo || e.detail.url_logo || ''
            });
        });

        document.addEventListener('radio-stop', (e) => {
            this.audio.pause();
            this.stopMusicIdentification();
        });

        // Listener para botão play/pause do music player
        this.setupPlayerControls();

        // Inicializar identificador de músicas
        this.initMusicIdentifier();

        // Não carregar rádio aleatória automaticamente - aguardar interação do usuário
        // this.loadRandomRadio();

        this.tryRestoreStreamHandoff().catch(() => {});

        document.addEventListener('radiospro:favorite-changed', (event) => {
            const detail = event.detail || {};
            if (!this.currentRadio || String(this.currentRadio.id) !== String(detail.radioId)) {
                return;
            }
            const favoriteBtn = this.getPlayerElement()?.querySelector('.music-radio-favorite');
            if (!favoriteBtn || !window.radioManager) return;
            window.radioManager.applyFavoriteStateToButton(favoriteBtn, !!detail.isFavorite);
        });
    }

    clearStreamHandoffStorage() {
        try {
            sessionStorage.removeItem(APPRADIO_STREAM_HANDOFF_KEY);
        } catch (e) {
            /* ignore */
        }
    }

    tryRestoreStreamHandoff() {
        // Na página da rádio (radio.php) há um player dedicado (#radio-detail-audio)
        // que já restaura o handoff. Se o MusicPlayerManager também restaurasse,
        // os dois <audio> tocariam o mesmo stream em dobro. Cede a vez ao dedicado.
        if (document.getElementById('radio-detail-audio')) {
            return Promise.resolve();
        }
        let data;
        try {
            const raw = sessionStorage.getItem(APPRADIO_STREAM_HANDOFF_KEY);
            if (!raw) return Promise.resolve();
            data = JSON.parse(raw);
        } catch (e) {
            this.clearStreamHandoffStorage();
            return Promise.resolve();
        }
        if (!data || data.v !== 1 || !data.streamUrl || !data.wasPlaying) {
            return Promise.resolve();
        }
        if (Date.now() - (data.ts || 0) > APPRADIO_STREAM_HANDOFF_TTL_MS) {
            this.clearStreamHandoffStorage();
            return Promise.resolve();
        }
        const radioId = data.radioId != null ? parseInt(data.radioId, 10) : 0;
        const radioName = data.radioName || 'Rádio';
        const savedVol = typeof data.volume === 'number' ? data.volume : null;
        return this.playRadio(data.streamUrl, radioName, radioId, {
            clearHandoff: false,
            fromHandoff: true,
            streamTitle: data.streamTitle || '',
            savedVolume: savedVol,
        });
    }

    setupPlayerControls() {
        const playButton = document.querySelector('.music-player .play-button');
        if (playButton) {
            playButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.togglePlayPause();
            });
        }

        const favoriteButton = document.querySelector('.music-player .music-radio-favorite');
        if (favoriteButton) {
            favoriteButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleCurrentRadioFavorite();
            });
        }

        if (!this._musicMarqueeResizeBound) {
            this._musicMarqueeResizeBound = true;
            window.addEventListener('resize', () => {
                if (this._musicMarqueeResizeTimer) clearTimeout(this._musicMarqueeResizeTimer);
                this._musicMarqueeResizeTimer = setTimeout(() => {
                    this.syncMusicMarquee();
                }, 200);
            });
        }
    }

    getPlayerElement() {
        return document.querySelector('.music-player');
    }

    syncMusicMarquee() {
        const playerElement = this.getPlayerElement();
        if (!playerElement) return;

        const measure = () => {
            playerElement.querySelectorAll('.rp-music-scroll').forEach((track) => {
                const text = track.querySelector('.rp-music-scroll__text');
                if (!text) return;

                track.classList.remove('is-scrolling');
                text.style.removeProperty('--scroll-distance');

                const distance = Math.ceil(text.scrollWidth - track.clientWidth);
                if (distance > 4) {
                    track.style.setProperty('--scroll-distance', `${distance}px`);
                    track.classList.add('is-scrolling');
                }
            });
        };

        requestAnimationFrame(() => {
            requestAnimationFrame(measure);
        });
    }

    updateRadioDetailsLink() {
        const playerElement = this.getPlayerElement();
        if (!playerElement) return;

        const detailsLink = playerElement.querySelector('.music-radio-details');
        if (!detailsLink) return;

        if (!this.currentRadio || !this.currentRadio.id) {
            detailsLink.hidden = true;
            detailsLink.removeAttribute('href');
            return;
        }

        const detailPath = typeof appradioRadioDetailPath === 'function'
            ? appradioRadioDetailPath(this.currentRadio.id, this.currentRadio.name)
            : `/radio/${this.currentRadio.id}`;
        detailsLink.href = detailPath;
        detailsLink.hidden = false;
    }

    buildFavoriteRadioDataFromCurrent() {
        if (!this.currentRadio || !this.currentRadio.id) return null;

        const radioId = this.currentRadio.id;
        const card = document.querySelector(`.radio-card[data-radio-id="${radioId}"]`);
        if (card && window.radioManager && typeof window.radioManager.buildRadioDataFromCard === 'function') {
            return window.radioManager.buildRadioDataFromCard(card, radioId);
        }

        const source = {
            id: radioId,
            title: this.currentRadio.name || '',
            url_logo: '',
            localizacao: '',
            segmento: '',
            streams: this.currentRadio.streamUrl ? [{ url: this.currentRadio.streamUrl }] : []
        };
        if (window.RadiosProFavorites && typeof window.RadiosProFavorites.buildPayload === 'function') {
            return window.RadiosProFavorites.buildPayload(source);
        }
        return source;
    }

    updatePlayerFavoriteButton() {
        const playerElement = this.getPlayerElement();
        if (!playerElement) return;

        const favoriteBtn = playerElement.querySelector('.music-radio-favorite');
        if (!favoriteBtn) return;

        if (!this.currentRadio || !this.currentRadio.id) {
            favoriteBtn.hidden = true;
            favoriteBtn.classList.remove('is-favorited');
            favoriteBtn.setAttribute('aria-pressed', 'false');
            return;
        }

        favoriteBtn.hidden = false;
        if (window.radioManager && typeof window.radioManager.refreshFavoriteButton === 'function') {
            window.radioManager.refreshFavoriteButton(favoriteBtn, this.currentRadio.id);
        }
    }

    toggleCurrentRadioFavorite() {
        if (!this.currentRadio || !this.currentRadio.id || !window.radioManager) return;

        const radioId = this.currentRadio.id;
        const card = document.querySelector(`.radio-card[data-radio-id="${radioId}"]`);
        const favoriteBtn = this.getPlayerElement()?.querySelector('.music-radio-favorite');

        if (card) {
            window.radioManager.toggleFavorite(card, radioId);
            if (favoriteBtn) {
                setTimeout(() => {
                    window.radioManager.refreshFavoriteButton(favoriteBtn, radioId);
                }, 0);
            }
            return;
        }

        if (!favoriteBtn) return;
        window.radioManager.toggleFavoriteTarget(radioId, favoriteBtn, () => this.buildFavoriteRadioDataFromCurrent());
    }

    initMusicIdentifier() {
        if (window.MusicIdentifier) {
            this.musicIdentifier = new MusicIdentifier({
                endpoint: '/ajax/identify-music.php',
                recordDuration: 8000,
                onSuccess: (result) => this.updateMusicInfo(result),
                onError: () => {
                    // Fallback: mostrar o nome da rádio quando não encontrar a música
                    const stationName = (this.currentRadio && this.currentRadio.name) ? this.currentRadio.name : 'Rádio';
                    this.updateMusicInfo({
                        title: stationName,
                        artist: 'AO VIVO',
                        coverart: null
                    });
                }
            });
        }
    }

    scheduleNextIdentification() {
        this.clearIdentificationTimer();
        // Reagendar se houver rádio atual (mesmo pausado)
        if (!this.currentRadio) {
            return;
        }
        this.identificationTimer = setTimeout(() => this.startMusicIdentification(), 30000);
    }

    clearIdentificationTimer() {
        if (this.identificationTimer) {
            clearTimeout(this.identificationTimer);
            this.identificationTimer = null;
        }
    }

    async startMusicIdentification() {
        const now = Date.now();
        
        if (this.isIdentifyingMusic || (now - this.lastIdentificationTime) < this.identificationCooldown) {
            this.scheduleNextIdentification();
            return;
        }

        if (!this.musicIdentifier || !this.currentRadio) {
            this.scheduleNextIdentification();
            return;
        }

        this.isIdentifyingMusic = true;
        this.lastIdentificationTime = now;

        // Mostrar mensagem de identificação
        this.updateMusicInfo({ title: 'Identificando música...', artist: '' });

        try {
            await this.musicIdentifier.identifyCurrentTrack(this.audio);
        } catch (_) {
            // Falha de identificação é esperada; onError já atualiza a UI
        } finally {
            this.isIdentifyingMusic = false;
            this.scheduleNextIdentification();
        }
    }

    stopMusicIdentification() {
        this.isIdentifyingMusic = false;
        this.lastIdentificationTime = 0;
        this.clearIdentificationTimer();
        
        // Cancelar gravação ativa se existir
        if (this.musicIdentifier) {
            this.musicIdentifier.cancelRecording();
        }
    }

    updateMusicInfo(trackData) {
        const playerElement = document.querySelector('.music-player');
        if (!playerElement) return;

        const musicTitle = playerElement.querySelector('.music-title-text');
        const musicArtist = playerElement.querySelector('.music-artist-text');
        const musicLabel = playerElement.querySelector('.music-label');

        const radioId = this.currentRadio ? this.currentRadio.id : null;
        const newTitle = (trackData.title || '').trim();
        const newArtist = (trackData.artist || '').trim();
        const newLabel = (trackData.label || '').trim();

        const isPlaceholder = !newTitle || newTitle === 'Identificando música...';
        const sameRadio = this.lastTrackRadioId === radioId;
        const sameTrack = sameRadio && this.lastTrackInfo &&
            this.lastTrackInfo.title === newTitle &&
            (this.lastTrackInfo.artist || '') === newArtist;

        // Se já temos info para esta rádio e veio placeholder ou vazio, não sobrescrever
        if (sameRadio && this.lastTrackInfo && isPlaceholder) {
            // Apenas atualiza coverart se houver nova
            if (trackData.coverart) {
                this.lastTrackInfo.coverart = trackData.coverart;
            }
            this.updateCoverart(this.lastTrackInfo ? this.lastTrackInfo.coverart : null);
            this.updatePlayerUI();
            return;
        }

        // Se veio mesma faixa, mantenha mas atualize coverart se necessário
        if (sameTrack) {
            if (trackData.coverart) {
                this.lastTrackInfo.coverart = trackData.coverart;
            }
            this.updateCoverart(this.lastTrackInfo ? this.lastTrackInfo.coverart : null);
            this.updatePlayerUI();
            return;
        }

        // Armazenar informação da música identificada
        if (newTitle) {
            this.lastTrackInfo = {
                title: newTitle,
                artist: newArtist,
                coverart: trackData.coverart || null
            };
            this.lastTrackRadioId = radioId;
        }

        if (musicTitle) {
            musicTitle.textContent = newTitle || 'Identificando música...';
        }
        if (musicArtist) {
            musicArtist.textContent = newArtist || '';
        }
        if (musicLabel && newLabel) {
            musicLabel.textContent = newLabel;
        }

        // Atualizar UI para mostrar coverart
        this.updatePlayerUI();
        this.syncMusicMarquee();
    }

    updateRadioLogo(logoUrl) {
        const playerElement = this.getPlayerElement();
        if (!playerElement) return;

        const playButton = playerElement.querySelector('.play-button');
        const artWrap = playButton && playButton.querySelector('.play-button-art');
        const logoImg = playButton && playButton.querySelector('.play-button-logo');
        if (!playButton || !artWrap || !logoImg) return;

        const url = (logoUrl || '').trim();
        if (!url) {
            artWrap.hidden = true;
            logoImg.removeAttribute('src');
            playerElement.classList.remove('has-station-logo');
            return;
        }

        logoImg.onerror = () => {
            artWrap.hidden = true;
            logoImg.removeAttribute('src');
            playerElement.classList.remove('has-station-logo');
        };
        logoImg.onload = () => {
            artWrap.hidden = false;
            playerElement.classList.add('has-station-logo');
        };
        if (logoImg.src !== url) {
            logoImg.src = url;
        } else if (logoImg.complete && logoImg.naturalWidth > 0) {
            artWrap.hidden = false;
            playerElement.classList.add('has-station-logo');
        }
    }

    updateCoverart(coverartUrl) {
        const playerElement = this.getPlayerElement();
        if (!playerElement) return;

        const playMusic = playerElement.querySelector('.play-music');
        if (!playMusic) return;

        // Verificar se já existe um elemento de coverart
        let coverartImg = playerElement.querySelector('.music-coverart');

        if (coverartUrl) {
            // Se não existe, criar
            if (!coverartImg) {
                coverartImg = document.createElement('img');
                coverartImg.className = 'music-coverart';
                coverartImg.alt = 'Album Cover';
                playMusic.appendChild(coverartImg);
            }
            // Atualizar src e mostrar
            coverartImg.src = coverartUrl;
            coverartImg.style.display = 'block';
            playerElement.classList.add('has-coverart');
        } else {
            // Sem coverart, ocultar se existir
            if (coverartImg) {
                coverartImg.style.display = 'none';
            }
            playerElement.classList.remove('has-coverart');
        }
    }

    handleAutoplayBlocked(radioName, radioId, opts) {
        const options = opts && typeof opts === 'object' ? opts : {};
        this.isPlaying = false;
        this.isLoading = false;
        this.hasPlaybackError = false;
        this.needsUserPlay = true;
        this.lastTrackInfo = null;
        this.lastTrackRadioId = radioId;
        const lineTitle = (options.streamTitle && String(options.streamTitle).trim()) || radioName;
        this.updateMusicInfo({
            title: lineTitle || radioName,
            artist: 'Toque em play para continuar',
            coverart: null
        });
        this.updatePlayerUI();
        document.dispatchEvent(new CustomEvent('radio-autoplay-blocked', {
            detail: {
                radioId: radioId,
                radioName: radioName || ''
            }
        }));
        this.emitStreamState('autoplay_blocked', {
            errorMessage: 'AUTOPLAY_BLOCKED'
        });
    }

    mediaErrorToString(code) {
        switch (code) {
            case 1: return 'MEDIA_ERR_ABORTED';
            case 2: return 'MEDIA_ERR_NETWORK';
            case 3: return 'MEDIA_ERR_DECODE';
            case 4: return 'MEDIA_ERR_SRC_NOT_SUPPORTED';
            default: return null;
        }
    }

    emitStreamState(state, extra) {
        const error = this.audio && this.audio.error ? this.audio.error : null;
        const detail = Object.assign({
            state,
            radioId: this.currentRadio ? this.currentRadio.id : null,
            radioName: this.currentRadio ? this.currentRadio.name : '',
            streamUrl: this.currentRadio ? this.currentRadio.streamUrl : '',
            errorCode: error ? error.code : null,
            errorMessage: error ? this.mediaErrorToString(error.code) : null,
            elapsedMs: this.streamAttemptStartedAt ? Date.now() - this.streamAttemptStartedAt : null
        }, extra || {});

        document.dispatchEvent(new CustomEvent('radiospro:stream-state', {
            detail
        }));
    }

    isHlsUrl(url) {
        return /\.m3u8(\?|$)/i.test(url || '');
    }

    destroyHls() {
        if (this.hls) {
            try { this.hls.destroy(); } catch (e) { /* ignore */ }
            this.hls = null;
        }
    }

    /** Carrega hls.js sob demanda (só para streams .m3u8 em navegadores sem HLS nativo). */
    loadHlsScript(cb) {
        if (window.Hls) { cb(null); return; }
        if (this._hlsPending) { this._hlsPending.push(cb); return; }
        this._hlsPending = [cb];
        const done = (err) => {
            const list = this._hlsPending || [];
            this._hlsPending = null;
            list.forEach((fn) => fn(err));
        };
        const s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.7/hls.min.js';
        s.async = true;
        s.onload = () => done(null);
        s.onerror = () => done(new Error('hls_load_failed'));
        document.head.appendChild(s);
    }

    /**
     * Liga o stream ao <audio> e inicia o play. Para HLS (.m3u8) usa hls.js
     * (ou o suporte nativo do Safari); para Icecast/Shoutcast usa a tag direta.
     * Retorna a Promise do play() para o fluxo de erro em playRadio.
     */
    bindAndPlay(streamUrl) {
        this.destroyHls();

        if (this.isHlsUrl(streamUrl)) {
            // Safari/iOS reproduzem HLS nativamente — dispensa hls.js.
            if (this.audio.canPlayType('application/vnd.apple.mpegurl')) {
                this.audio.src = streamUrl;
                this.audio.load();
                return this.audio.play();
            }
            return new Promise((resolve, reject) => {
                this.loadHlsScript((err) => {
                    if (err || !window.Hls || !window.Hls.isSupported()) {
                        reject(new Error('hls_unavailable'));
                        return;
                    }
                    const hls = new window.Hls({ maxBufferLength: 30, liveSyncDurationCount: 3 });
                    this.hls = hls;
                    let settled = false;
                    hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
                        this.audio.play()
                            .then(() => { if (!settled) { settled = true; resolve(); } })
                            .catch((e) => { if (!settled) { settled = true; reject(e); } });
                    });
                    hls.on(window.Hls.Events.ERROR, (_, data) => {
                        if (data && data.fatal && !settled) { settled = true; reject(new Error('hls_fatal')); }
                    });
                    hls.loadSource(streamUrl);
                    hls.attachMedia(this.audio);
                });
            });
        }

        // Streams progressivos: cache-buster para forçar o "ao vivo" e evita modo CORS.
        const cacheBustedUrl = streamUrl.includes('?')
            ? `${streamUrl}&t=${Date.now()}`
            : `${streamUrl}?t=${Date.now()}`;
        this.audio.src = cacheBustedUrl;
        this.audio.load();
        return this.audio.play();
    }

    async playRadio(streamUrl, radioName, radioId, options) {
        if (!streamUrl) {
            console.error('URL do stream não fornecida');
            return;
        }

        const opts = options && typeof options === 'object' ? options : {};
        const fromHandoff = !!opts.fromHandoff;
        const clearHandoff = opts.clearHandoff !== false;

        try {
            if (clearHandoff) {
                this.clearStreamHandoffStorage();
            }

            // Se já está tocando esta rádio, pausar
            if (this.currentRadio && this.currentRadio.id === radioId && !this.audio.paused) {
                this.audio.pause();
                return;
            }

            // Parar identificação atual se estiver trocando de rádio
            if (this.currentRadio && this.currentRadio.id !== radioId) {
                this.stopMusicIdentification();
                // Limpar informação da música anterior ao trocar de rádio
                this.lastTrackInfo = null;
            }

            // Atualizar informações da rádio atual
            this.currentRadio = {
                id: radioId,
                name: radioName,
                streamUrl: streamUrl,
                url_logo: opts.urlLogo || opts.url_logo || ''
            };

            if (this.musicIdentifier && typeof this.musicIdentifier.setRadioId === 'function') {
                this.musicIdentifier.setRadioId(radioId);
            }

            this.hasPlaybackError = false;
            this.needsUserPlay = false;
            this.isLoading = true;
            this.isPlaying = false;
            this.streamAttemptStartedAt = Date.now();
            this.updatePlayerUI();

            // Limpar timers anteriores
            this.clearIdentificationTimer();

            if (fromHandoff && typeof opts.savedVolume === 'number' && opts.savedVolume >= 0 && opts.savedVolume <= 1) {
                this.audio.volume = opts.savedVolume;
            }

            // Liga o stream (HLS via hls.js ou tag <audio> para Icecast/Shoutcast) e toca.
            await this.bindAndPlay(streamUrl);

            if (fromHandoff) {
                this.clearStreamHandoffStorage();
            }

            // Atualizar interface
            this.updatePlayerUI();
            
            // Mostrar mensagem inicial
            this.updateMusicInfo({ title: 'Identificando música...', artist: '' });

            // Iniciar identificação de música após um pequeno delay
            setTimeout(() => this.startMusicIdentification(), 2000);

        } catch (error) {
            // AbortError é normal quando o usuário pausa antes de carregar
            if (error.name === 'AbortError') {
                console.log('Reprodução interrompida pelo usuário.');
                this.emitStreamState('aborted', {
                    errorMessage: 'PLAY_ABORTED'
                });
                return;
            }

            if (error.name === 'NotAllowedError') {
                this.handleAutoplayBlocked(radioName, radioId, opts);
                return;
            }
            
            console.error('Erro ao tocar rádio:', error);
            this.isPlaying = false;
            this.isLoading = false;
            this.hasPlaybackError = true;
            this.updatePlayerUI();
            this.emitStreamState('error', {
                errorMessage: error && error.name ? error.name : 'PLAY_FAILED'
            });
             
            // Atualizar UI com mensagem de erro
            this.updateMusicInfo({
                title: 'Não foi possível tocar.',
                artist: 'Formato de áudio não suportado ou stream indisponível.',
                label: 'Rádio indisponível'
            });
            if (fromHandoff) {
                this.clearStreamHandoffStorage();
            }
        }
    }

    togglePlayPause() {
        if (!this.currentRadio) {
            // Se não há rádio carregada, carregar uma aleatória
            this.loadRandomRadio();
            return;
        }

        if (this.audio.paused) {
            // Recarregar o stream para voltar ao vivo. Com hls.js ativo, evita
            // audio.load() (que desanexaria o hls) — basta retomar o play.
            try {
                if (!this.hls) {
                    this.audio.load();
                }
                const p = this.audio.play();
                if (p && typeof p.then === 'function') {
                    p.then(() => this.clearStreamHandoffStorage()).catch(() => {});
                } else {
                    this.clearStreamHandoffStorage();
                }
            } catch (error) {
                console.error('Erro ao retomar reprodução:', error);
            }
        } else {
            this.clearStreamHandoffStorage();
            this.audio.pause();
        }
    }

    updatePlayerUI() {
        const playerElement = document.querySelector('.music-player');
        if (!playerElement) return;

        const playButton = playerElement.querySelector('.play-button');
        const musicLabel = playerElement.querySelector('.music-label');
        const musicTitle = playerElement.querySelector('.music-title-text');
        const musicArtist = playerElement.querySelector('.music-artist-text');
        const musicStation = playerElement.querySelector('.music-station');

        // Atualizar classes de estado
        if (this.isLoading) {
            playerElement.classList.add('loading');
            playerElement.classList.remove('playing', 'has-error');
        } else if (this.isPlaying) {
            playerElement.classList.add('playing');
            playerElement.classList.remove('loading', 'has-error');
            this.hasPlaybackError = false;
        } else if (this.hasPlaybackError) {
            playerElement.classList.add('has-error');
            playerElement.classList.remove('playing', 'loading', 'needs-user-play');
        } else if (this.needsUserPlay) {
            playerElement.classList.add('needs-user-play');
            playerElement.classList.remove('playing', 'loading', 'has-error');
        } else {
            playerElement.classList.remove('playing', 'loading', 'has-error', 'needs-user-play');
        }

        if (this.currentRadio) {
            // Atualizar nome da rádio
            if (musicStation) {
                musicStation.textContent = this.currentRadio.name;
            }
            this.updateRadioLogo(this.currentRadio.url_logo);

            // Preservar informações da última música identificada
            if (this.lastTrackInfo) {
                if (musicTitle) {
                    musicTitle.textContent = this.lastTrackInfo.title;
                }
                if (musicArtist) {
                    musicArtist.textContent = this.lastTrackInfo.artist;
                }
                
                // Adicionar/atualizar coverart
                this.updateCoverart(this.lastTrackInfo.coverart);
            } else {
                // Sem música identificada ainda
                if (musicTitle) {
                    if (this.hasPlaybackError) {
                        musicTitle.textContent = 'Não foi possível tocar.';
                    } else {
                        musicTitle.textContent = this.isIdentifyingMusic ? 'Identificando música...' : '';
                    }
                }
                if (musicArtist) {
                    if (this.hasPlaybackError) {
                        musicArtist.textContent = 'Formato de áudio não suportado ou stream indisponível.';
                    } else {
                        musicArtist.textContent = this.isIdentifyingMusic ? 'Aguarde...' : 'AO VIVO';
                    }
                }
                // Remover coverart se não houver música
                this.updateCoverart(null);
            }

            // Atualizar label baseado no status
            if (musicLabel) {
                if (this.isLoading) {
                    musicLabel.textContent = 'Carregando...';
                } else if (this.hasPlaybackError) {
                    musicLabel.textContent = 'Rádio indisponível';
                } else if (this.needsUserPlay) {
                    musicLabel.textContent = 'Toque em play';
                } else {
                    musicLabel.textContent = this.isPlaying ? 'Tocando agora' : 'Pausado';
                }
            }
        } else {
            // Estado inicial sem rádio carregada
            if (musicStation) {
                musicStation.textContent = 'Nenhuma rádio selecionada';
            }
            if (musicTitle) {
                musicTitle.textContent = '';
            }
            if (musicArtist) {
                musicArtist.textContent = '';
            }
            if (musicLabel) {
                musicLabel.textContent = 'Pronto para tocar';
            }
            this.updateCoverart(null);
            this.updateRadioLogo(null);
        }

        this.updateRadioDetailsLink();
        this.updatePlayerFavoriteButton();
        requestAnimationFrame(() => {
            this.syncMusicMarquee();
        });
    }

    async loadRandomRadio() {
        this.isLoading = true;
        this.updatePlayerUI();

        try {
            const response = await fetch('/ajax/radio-search.php?action=get-radios&page=1&search=&segment=');
            const data = await response.json();

            if (data.success && data.radios && data.radios.length > 0) {
                const randomRadio = data.radios[Math.floor(Math.random() * data.radios.length)];
                const streamUrl = randomRadio.streams && randomRadio.streams.length > 0 ? randomRadio.streams[0].url : null;

                if (streamUrl) {
                    this.playRadio(streamUrl, randomRadio.title, randomRadio.id, {
                        urlLogo: randomRadio.url_logo || ''
                    });
                    return;
                }
            }

            this.isLoading = false;
            this.updatePlayerUI();
        } catch (error) {
            console.error('Erro ao carregar rádio aleatória:', error);
            this.isLoading = false;
            this.updatePlayerUI();
        }
    }
}

// Inicializar o music player quando o DOM estiver pronto
rpOnReady( () => {
    window.musicPlayerManager = new MusicPlayerManager();
});

// Interação: dispositivos reagem levemente ao mouse (parallax/tilt)
(function devicesParallax() {
    const container = document.querySelector('.mobile-devices');
    if (!container) return;
    const phone = container.querySelector('.device.phone');
    const tablet = container.querySelector('.device.tablet');
    if (!phone || !tablet) return;

    function onMove(e) {
        const rect = container.getBoundingClientRect();
        const x = (e.clientX - rect.left) / (rect.width || 1); // 0..1
        const y = (e.clientY - rect.top) / (rect.height || 1); // 0..1
        const dx = (x - 0.5) * 2; // -1..1
        const dy = (y - 0.5) * 2; // -1..1

        // amplitudes
        const phoneAmp = { x: 14, y: 10, rot: 4 };
        const tabletAmp = { x: 9, y: 6, rot: 2.5 };

        // aplicar leve deslocamento na direção do mouse
        phone.style.transform = `translate(${dx * phoneAmp.x}px, ${dy * phoneAmp.y}px) rotate(${dx * phoneAmp.rot}deg)`;
        tablet.style.transform = `translate(${dx * tabletAmp.x}px, ${dy * tabletAmp.y}px) rotate(${dx * tabletAmp.rot}deg)`;
    }

    function reset() {
        phone.style.transform = '';
        tablet.style.transform = '';
    }

    container.addEventListener('mousemove', onMove);
    container.addEventListener('mouseleave', reset);
})();

// Initialize Swiper for radio carousel
(function initSwiperRadio() {
    const swiperRadio = document.querySelector('.swiper-radio');
    const swiperSection = document.querySelector('.swiper-radio-section');
    if (!swiperRadio || !swiperSection) return;
    
    const paginationEl = swiperSection.querySelector('.swiper-pagination');
    if (!paginationEl) return;
    
    const swiper = new Swiper('.swiper-radio', {
        slidesPerView: 1,
        spaceBetween: 18,
        loop: true,
        speed: 800, // Velocidade da transição suave para animação infinita
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            dynamicBullets: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 18,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 18,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 18,
            },
        },
    });
    
    // Control button for play/pause
    const controlBtn = swiperSection.querySelector('.swiper-radio-control-btn');
    if (controlBtn) {
        // Inicializa o estado do botão (pausado mostra play, rodando mostra pause)
        controlBtn.classList.remove('paused');
        
        // Função para atualizar o ícone do botão
        function updateButtonIcon() {
            if (swiper.autoplay.running) {
                controlBtn.classList.remove('paused');
            } else {
                controlBtn.classList.add('paused');
            }
        }
        
        // Adiciona listener para mudanças no autoplay
        swiper.on('autoplayStart', () => {
            updateButtonIcon();
        });
        
        swiper.on('autoplayStop', () => {
            updateButtonIcon();
        });
        
        // Listener para o clique no botão
        controlBtn.addEventListener('click', () => {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
                controlBtn.classList.add('paused');
                controlBtn.setAttribute('aria-label', 'Reproduzir carrossel');
            } else {
                swiper.autoplay.start();
                controlBtn.classList.remove('paused');
                controlBtn.setAttribute('aria-label', 'Pausar carrossel');
            }
        });
        
        // Atualiza o ícone inicial
        updateButtonIcon();
    }
    
    // Expose Swiper instance for search functionality
    swiperRadio._swiper = swiper;
})();

// Initialize Swiper for main carousel
(function initSwiperMain() {
    const swiperMain = document.querySelector('.swiper-main');
    const swiperMainSection = document.querySelector('.swiper-main-section');
    if (!swiperMain || !swiperMainSection) return;
    
    const paginationEl = swiperMainSection.querySelector('.swiper-pagination-main');
    if (!paginationEl) return;
    
    const swiper = new Swiper('.swiper-main', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            dynamicBullets: true,
        },
        watchSlidesProgress: true,
        on: {
            slideChange: function() {
                // Update opacity for inactive slides
                const slides = this.slides;
                slides.forEach((slide, index) => {
                    if (index === this.activeIndex) {
                        slide.querySelector('.carrossel-content')?.classList.add('active');
                    } else {
                        slide.querySelector('.carrossel-content')?.classList.remove('active');
                    }
                });
            },
        },
    });
    
    // Initial opacity update
    swiper.slides.forEach((slide, index) => {
        if (index === swiper.activeIndex) {
            slide.querySelector('.carrossel-content')?.classList.add('active');
        } else {
            slide.querySelector('.carrossel-content')?.classList.remove('active');
        }
    });
    
    // Handle slide clicks to navigate
    swiper.slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
            // Don't navigate if clicking on button/link
            if (e.target.closest('button') || e.target.closest('a')) {
                return;
            }
            const slideIndex = swiper.getSlideIndex(slide);
            if (slideIndex !== swiper.activeIndex) {
                swiper.slideTo(slideIndex);
            }
        });
    });
    
    // Expose Swiper instance
    swiperMain._swiper = swiper;
})();

/* ==================================================
   Radio Stream Player (single persistent audio element)
   Cards must include a data-stream="<stream-url>" attribute on .radio-card
   Clicking the .radio-play-btn will toggle playback for that card's stream.
   ================================================== */
(function () {
    'use strict';

    // Single audio instance reused for all streams
    const radioAudio = new Audio();
    // Allow browser to preload so autoplay attempts have a chance. Note: many browsers
    // still block autoplay with sound until user interacts — playCard handles blocked
    // attempts and shows a small hint to the user.
    radioAudio.preload = 'auto';
    radioAudio.crossOrigin = 'anonymous';

    let activeCard = null;

    // Helper to dispatch custom events for external music-player integration
    function dispatchPlayerEvent(name, detail) {
        try {
            const ev = new CustomEvent(name, { detail });
            document.dispatchEvent(ev);
        } catch (e) {
            // older browsers: fallback to window event
            try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch (err) { /* ignore */ }
        }
    }

    function setCardPlaying(card, playing) {
        if (!card) return;
        card.classList.toggle('is-playing', playing);
        const btn = card.querySelector('.radio-play-btn');
        if (btn) {
            btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
            if (playing) {
                // replace inner with pause icon
                btn.dataset.prev = btn.innerHTML;
                btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>';
            } else {
                if (btn.dataset.prev) {
                    btn.innerHTML = btn.dataset.prev;
                    delete btn.dataset.prev;
                }
            }
        }
        // Dispatch events so other UI (e.g. a site music-player) can sync
        const stream = card?.dataset?.stream || null;
        const title = card?.querySelector('h3')?.textContent?.trim() || null;
        if (playing) dispatchPlayerEvent('radioplayer:play', { stream, title, card });
        else dispatchPlayerEvent('radioplayer:pause', { stream, title, card });
    }

    function stopActive() {
        if (activeCard) {
            setCardPlaying(activeCard, false);
            activeCard = null;
        }
        // If there's a site-wide music player, try to stop its audio too
        const musicPlayerEl = document.querySelector('#music-player, .music-player');
        if (musicPlayerEl) {
            try {
                const innerAudio = musicPlayerEl.querySelector && musicPlayerEl.querySelector('audio');
                if (innerAudio && !innerAudio.paused) innerAudio.pause();
                if (typeof musicPlayerEl.stopStream === 'function') {
                    // custom element API support
                    try { musicPlayerEl.stopStream(); } catch (e) { /* ignore */ }
                }
            } catch (e) {
                // defensive: don't break stopping logic
                console.warn('Error stopping site music-player', e);
            }
        }

        if (!radioAudio.paused) {
            radioAudio.pause();
        }
        radioAudio.src = '';
    }

    async function playCard(card) {
        const stream = card?.dataset?.stream;
        if (!stream) return;

        // If clicking same card toggle play/pause
        if (activeCard === card) {
            if (radioAudio.paused) {
                try { await radioAudio.play(); setCardPlaying(card, true); } catch (e) { console.error(e); setCardPlaying(card, false); }
            } else {
                radioAudio.pause();
                setCardPlaying(card, false);
            }
            return;
        }

        // Stop previous
        stopActive();
        activeCard = card;
        setCardPlaying(card, true);

        // Prefer delegating playback to a site-wide music player if present.
        const musicPlayerEl = document.querySelector('#music-player, .music-player');
        if (musicPlayerEl) {
            // Try custom API first
            if (typeof musicPlayerEl.playStream === 'function') {
                try {
                    await musicPlayerEl.playStream(stream);
                    // notify listeners
                    dispatchPlayerEvent('radioplayer:play', { stream, title: card?.querySelector('h3')?.textContent?.trim() || null, card });
                    return; // success
                } catch (e) {
                    console.error('music-player.playStream failed, falling back to internal player', e);
                    // continue to fallback
                }
            }

            // Fallback: if the music-player contains an <audio> element, use it
            try {
                const innerAudio = musicPlayerEl.querySelector && musicPlayerEl.querySelector('audio');
                if (innerAudio) {
                    innerAudio.src = stream;
                    innerAudio.load();
                    try {
                        await innerAudio.play();
                        // mark music-player as playing for potential UI hooks
                        try { musicPlayerEl.classList.add('is-playing'); } catch (e) {}
                        // dispatch play event so external UI can update
                        dispatchPlayerEvent('radioplayer:play', { stream, title: card?.querySelector('h3')?.textContent?.trim() || null, card });
                        // keep innerAudio events synced to card state
                        innerAudio.addEventListener('pause', () => setCardPlaying(card, false));
                        innerAudio.addEventListener('ended', () => { setCardPlaying(card, false); activeCard = null; });
                        innerAudio.addEventListener('error', (ev) => { console.error('music-player inner audio error', ev); dispatchPlayerEvent('radioplayer:error', { stream, title: card?.querySelector('h3')?.textContent?.trim() || null, card }); setCardPlaying(card, false); activeCard = null; });
                        return;
                    } catch (e) {
                        console.error('music-player audio failed to play, falling back', e);
                        // continue to internal fallback
                    }
                }
            } catch (e) {
                console.warn('Error interacting with music-player element', e);
            }
        }

        // Fallback to built-in audio element
        radioAudio.src = stream;
        radioAudio.load();
        try {
            await radioAudio.play();
            // dispatch play event for external listeners
            dispatchPlayerEvent('radioplayer:play', { stream, title: card?.querySelector('h3')?.textContent?.trim() || null, card });
        } catch (err) {
            console.error('Playback failed', err);
            // Do not insert DOM hints — log only and update UI state
            setCardPlaying(card, false);
            activeCard = null;
        }
    }

    document.addEventListener('click', (ev) => {
        const btn = ev.target.closest('.radio-play-btn');
        if (!btn) return;
        ev.preventDefault();
        const card = btn.closest('.radio-card');
        if (!card) return;
        playCard(card);
    });

    // Update UI when audio is paused/ended/error
    radioAudio.addEventListener('pause', () => {
        if (activeCard) setCardPlaying(activeCard, false);
        // notify external listeners
        if (activeCard) dispatchPlayerEvent('radioplayer:pause', { stream: activeCard.dataset?.stream || null, title: activeCard.querySelector('h3')?.textContent?.trim() || null, card: activeCard });
    });
    radioAudio.addEventListener('ended', () => {
        if (activeCard) setCardPlaying(activeCard, false);
        activeCard = null;
        dispatchPlayerEvent('radioplayer:pause', { stream: null, title: null, card: null });
    });
    radioAudio.addEventListener('error', (ev) => {
        console.error('Audio element error', ev || radioAudio.error);
        if (activeCard) {
            setCardPlaying(activeCard, false);
            activeCard = null;
            dispatchPlayerEvent('radioplayer:error', { stream: null, title: null, card: null });
        }
    });

    // Keep playing across tabs: do NOT pause on visibility change so audio continues
    // when the user switches to another browser tab. Autoplay attempts were removed
    // to require an explicit user interaction with the station or the music-player.

})();

// Splash de carregamento — oculta quando o grid de rádios fica pronto
(function () {
    var splash = document.getElementById('rp-splash');
    if (!splash) return;

    var dismissed = false;
    function dismissSplash() {
        if (dismissed) return;
        dismissed = true;
        document.body.classList.remove('rp-loading');
        splash.classList.add('rp-splash--done');
    }

    // Fecha assim que o grid de rádios estiver pronto ou quando surgir a tela de erro.
    document.addEventListener('rp-radios-grid-ready', dismissSplash, { once: true });
    document.addEventListener('rp-radios-load-error', dismissSplash, { once: true });

    // Fallback resiliente: NÃO remove a splash às cegas por tempo. Só encerra cedo
    // quando o grid já tem conteúdo real (cards ou painel de erro). Enquanto a rede
    // ainda responde, mantém a splash e continua verificando — evita a "tela vazia".
    // Um teto máximo garante que a splash nunca fique presa indefinidamente.
    var HARD_CAP_MS = 20000;
    var start = Date.now();
    (function watchGrid() {
        if (dismissed || !document.body.contains(splash)) return;
        var grid = document.getElementById('dynamic-radio-grid');
        var hasContent = grid && (
            grid.querySelector('.radio-card') ||
            grid.querySelector('.radio-load-error')
        );
        if (hasContent) { dismissSplash(); return; }
        if (Date.now() - start >= HARD_CAP_MS) { dismissSplash(); return; }
        setTimeout(watchGrid, 250);
    }());
}());

}
